import { useEffect } from 'react';

import HeaderMenuListView from '../../../views/HeaderMenuListView/HeaderMenuListView';
import menu from '../../../JSON/menu.json';

const MenuList = props => {
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    window.addEventListener('click', handleOutModalClick);
    return () => {
      window.removeEventListener('click', handleOutModalClick);
    };
  }, [handleOutModalClick]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function handleOutModalClick(event) {
    if (event.currentTarget !== event.target) {
      props.onClose();
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function handleKeyDown(event) {
    if (event.code === 'Escape') {
      props.onClose();
    }
  }

  return (
    <>
      <HeaderMenuListView menu={menu} onClick={handleOutModalClick} />
    </>
  );
};

export default MenuList;
